import * as _ from "lodash";
import { ICanvasListeners } from "../widgets/interfaces/CanvasListeners";
import { generateUUID } from "./reducers/util";

/**
 * Handle events for canvas changes, call appropriate registered listeners.
 * Listeners are passed to CanvasApp as initialization parameters.
 *
 * @class EventHandler
 */
class EventHandler {
	private canvasListenersMap: {
        [key: string]: ICanvasListeners;
    } = {};

	/**
     * Set listeners for the app.
     *
     * @param {ICanvasListeners} listeners
     * @returns Token. Use this to remove listener after use
     */
	public setListeners = (listeners: ICanvasListeners): string => {
		if (!this.canvasListenersMap) {
			this.canvasListenersMap = {};
		}
		const token = generateUUID();
		this.canvasListenersMap[token] = listeners;
		return token;
	};

	/**
     * Remove listener from event handler
     * @param token{string} Listener token to remove. This token was returned when listener was set using setListeners()
     * method
     */
	public removeListeners = (token: string) => {
		delete this.canvasListenersMap[token];
	};

	/**
     * Emit event, call appropriate listeners.
     * @param {string} eventName event to be called.
     * @param {any} payload data to be passed along with event.
     */
	public emit = (eventName: string, payload?: any) => {
		if (this.canvasListenersMap) {
			_.forEach(this.canvasListenersMap, (listenerObject: any) => {
				const callback = listenerObject[eventName];
				requestAnimationFrame(() => callback && callback(payload));
			});
		}
	};
};

export const eventHandler = new EventHandler();
